import React, { useState, KeyboardEvent, useEffect, useRef } from 'react';
import FormInput from 'components/general/form_input/form_input';
import Textarea from 'components/form/textarea/textarea';
import Button from 'components/general/button/Button';
interface Question {
  id: number;
  mandatory: boolean;
  question_text: string;
  answer_text: string | null;
}
interface QuestionStepProps {
  question: Question;
  questionNumber: number;
  initialAnswer: string;
  onNext: (questionId: number, answer: string, isLastQuestion: boolean) => void;
  onPrevious: () => void;
  isLastQuestion?: boolean;
}

const QuestionStep: React.FC<QuestionStepProps> = ({
  question,
  questionNumber,
  initialAnswer,
  onNext,
  onPrevious,
  isLastQuestion = false,
}) => {
  const styles = require('./Step.module.scss');
  const [answer, setAnswer] = useState(initialAnswer);
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  
  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.focus();
    }
  }, []);

  const disableNext = question.mandatory && answer.trim() === '';

  const handleNext = () => {
    if (disableNext) return;
    onNext(question.id, answer, isLastQuestion);
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLTextAreaElement>) => {
    if ((e.key === 'Enter' && !e.shiftKey) || e.key === 'Go') {
      e.preventDefault();
      handleNext();
    }
  };

  return (
    <>
      <div className={styles.form}>
        <FormInput
          required={question.mandatory}
          label={`${questionNumber}. ${question.question_text}`}
          labelClass={styles.inputsText}
        >
          <Textarea
            placeholder="Type your answer here"
            className={styles.questionTextarea}
            defaultValue={answer}
            handleChange={(e) => setAnswer(e.target.value)}
            handleKeyDown={handleKeyDown}
            rows={6}
            maxLength={2000}
            showCharacterCount
            textareaRef={textareaRef}
          />
        </FormInput>
      </div>

      <div className={styles.footer}>
        <Button
          onClick={onPrevious}
          type="Secondary"
          size="M"
          iconLeftName="chevronLeft"
          className={styles.actionButton}
        >
          Previous
        </Button>
        
        <Button
          onClick={handleNext}
          disabled={disableNext}
          size="M"
          iconRightName={isLastQuestion ? undefined : 'chevronRight'}
          className={styles.actionButton}
        >
          {isLastQuestion ? 'Apply' : 'Next'}
        </Button>
      </div>
    </>
  );
};

export default QuestionStep;
